import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { MaintenanceRoyalDecreeComponent } from "./maintenance-royal-decree.component";
import { ListAvailableFieldsComponent } from "./list-available-fields/list-available-fields.component";
import { SpecificFieldsRequestedComponent } from "./specific-fields-requested/specific-fields-requested.component";
import { AvailableFieldsComponent } from "./available-fields/available-fields.component";
import { LoginGuard } from "../core/guards/login.guard";
import { PwdExpiratedGuard } from "../core/guards/pwdExpirated";

const routesRoyalDecree: Routes = [
  {
    path: "",
    component: MaintenanceRoyalDecreeComponent,
    canActivate: [LoginGuard, PwdExpiratedGuard],
    children: [
      {
        path: "lista-campos-disponibles",
        component: ListAvailableFieldsComponent,
      },
      {
        path: "campos-especificos-solicitados",
        component: SpecificFieldsRequestedComponent,
      },
      {
        path: "edicion-campos-disponibles/:id",
        component: AvailableFieldsComponent,
        data: {
          operation: "edicion",
        },
      },
      {
        path: "creacion-campos-disponibles",
        component: AvailableFieldsComponent,
        data: {
          operation: "creacion",
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routesRoyalDecree)],
  exports: [RouterModule],
})
export class RoyalDecreeRoutingModule {}
